import { render, staticRenderFns } from "./AgeIcon.vue?vue&type=template&id=76b1296c"
import script from "./AgeIcon.vue?vue&type=script&lang=js"
export * from "./AgeIcon.vue?vue&type=script&lang=js"
import style0 from "./AgeIcon.vue?vue&type=style&index=0&id=76b1296c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports